import { useMemo, useRef, useState } from 'react';
export const useAgreementCheckboxWrapper = (checkboxes) => {
    const checkboxesRef = useRef(null);
    const [checkedCheckboxes, setCheckedCheckboxes] = useState(checkboxes.map(item => (Object.assign(Object.assign({}, item), { checked: false }))));
    const isValid = useMemo(() => checkedCheckboxes.every(item => item.checked), [checkedCheckboxes]);
    const onChange = (fieldName) => {
        setCheckedCheckboxes(prev => prev.map(item => (item.fieldName === fieldName ? Object.assign(Object.assign({}, item), { checked: !item.checked }) : item)));
    };
    const scrollToCheckboxes = () => {
        checkboxesRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    return {
        // data
        checkboxesRef,
        isValid,
        // checkboxes
        checkedCheckboxes,
        // methods
        onChange,
        scrollToCheckboxes
    };
};
